
<div class="main-page-content">
  <div class="main-page-content-block" *ngIf="currentItem==null && !loadingCurrentItem">
    <p-table #dt1
             dataKey="Number"
             [value]="list"
             [responsive]="true"
             [paginator]="true"
             [rows]="25"
             [loading]="loadingList"
             [showCurrentPageReport]="true"
             currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
             [rowsPerPageOptions]="[10, 25, 50, 100, 1000]"
             styleClass="p-datatable-sm p-datatable-gridlines p-datatable-striped  "
             sortField="CreatedAt"
             [sortOrder]="-1"
             [expandedRowKeys]="expandedRows"
             (onRowExpand)="onRowExpand($event)"
             (onRowCollapse)="onRowCollapse($event)">

      <ng-template pTemplate="caption">
        <div class="d-flex justify-content-end">
          <div class="p-2 flex-fill"><h1 class="content-heading-font">Release Notes</h1></div>
          <div class="ml-auto">
            <button class="btn btn-success me-2" (click)="doPrepareReleaseItems()" title="Prepare Release Items" [class.button-loading]="loadingPrepareReleaseItems">
              Prepare Release Items
            </button>
            <button class="btn btn-success me-2" (click)="doReleaseToProduction()" title="Release to Production" [class.button-loading]="loadingReleaseToProduction">
              Release to Production
            </button>
            <button class="btn btn-success me-2" (click)="doArchiveReleaseItems()" title="Archive Release Items" [class.button-loading]="loadingArchiveReleaseItems">
              Archive Release Items
            </button>
            &nbsp;
            <button class="btn btn-primary" (click)="loadTable(null)" title="Refresh">
              <i class="pi pi-refresh" [ngClass]="{'pi-spin': loadingList}"></i>
            </button>
            &nbsp;
            <button class="btn btn-primary" (click)="clear(dt1)" title="Clear Filter">
              <i class="pi pi-filter-slash"></i>
            </button>
          </div>
        </div>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <th class="text-center" style="width:70px;"></th>
          <th pSortableColumn="Number" class="text-center text-nowrap" style="width:150px;">
            PR <p-sortIcon field="Number"></p-sortIcon>
            <p-columnFilter type="numeric" field="Number" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
          </th>
          <th pSortableColumn="Title" class="text-start">
            Title <p-sortIcon field="Title"></p-sortIcon>
            <p-columnFilter type="text" field="Title" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
          </th>
          <th pSortableColumn="CreatedAt" class="text-center" style="width:150px;">
            Created <p-sortIcon field="CreatedAt"></p-sortIcon>
            <p-columnFilter type="date" field="CreatedAt" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
          </th>
          <th pSortableColumn="MergedAt" class="text-center" style="width:150px;">
            Merged <p-sortIcon field="MergedAt"></p-sortIcon>
            <p-columnFilter type="date" field="MergedAt" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
          </th>
          <th pSortableColumn="State" class="text-center d-none d-md-table-cell" style="width:160px;">
            PR State <p-sortIcon field="State"></p-sortIcon>
            <p-columnFilter type="text" field="State" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
          </th>
          <th pSortableColumn="State" class="text-center d-none d-md-table-cell" style="width:160px;">
            Note State <p-sortIcon field="State"></p-sortIcon>
            <p-columnFilter type="text" field="State" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-item let-expanded="expanded">
        <tr>
          <td class="text-center text-nowrap">
            <a class="btn btn-sm btn-secondary" [href]="getLink(item)" target="_blank" title="Open GitHub PR">
              <i class="pi pi-external-link"></i>
            </a>
            <p-button type="button" pRipple [pRowToggler]="item" [text]="true" [rounded]="true" [plain]="true" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" />
          </td>
          <td class="text-center text-nowrap fw-bold">
            <a href="#" [routerLink]="['/releasenotes/'+  item.Number ]">
              #{{ item.Number }}
            </a>
          </td>
          <td class="text-start text-break">
            {{ item.Title }}
          </td>
          <td class="text-center text-nowrap">
            <span>{{ item.CreatedAt | date: 'short' }}</span>
          </td>
          <td class="text-center text-nowrap">
            <span>{{ item.MergedAt | date: 'short' }}</span>
          </td>
          <td class="text-center d-none d-md-table-cell text-truncate" style="max-width:160px;">
            <span *ngIf="item.State=='open'" class="badge bg-info">Open</span>
            <span *ngIf="item.State=='closed'" class="badge bg-success  text-dark">Closed</span>
            <span *ngIf="item.State!='closed' && item.State!='open'" class="badge bg-danger text-dark">{{ item.State || '-' }}</span>

          </td>
          <td class="text-center d-none d-md-table-cell text-truncate" style="max-width:160px;">
            <span *ngIf="item.ReleaseNotesStatus=='Processing'" class="badge bg-info">Processing</span>
            <span *ngIf="item.ReleaseNotesStatus=='Done'" class="badge bg-success  text-dark">Done</span>
            <span *ngIf="item.ReleaseNotesStatus=='Requested'" class="badge bg-danger text-dark">Requested</span>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="expandedrow" let-item>
        <tr>
          <td colspan="7">
            <div *ngIf="!item.ReleaseNotes && !item.Items && loadingDetails" class="alert alert-warning mb-0 button-loading">
              Loading
            </div>
            <table class="table table-sm  pb-2" *ngIf="item.Items && item.Items.length>0">
              <thead>
                <tr>
                  <th class="text-center">Issue #</th>
                  <th>Title</th>
                  <th class="text-center">Issue Status</th>
                  <th class="text-center">Ticket Status</th>
                  <th>Author</th>
                  <th>Assignees</th>
                  <th>Labels</th>
                  <th class="text-center">Last Updated</th>
                </tr>
              </thead>
              <tbody *ngFor="let issue of item.Items">
                <tr>
                  <th class="text-center">
                    <a [href]="getItemLink(issue)" target="_blank">#{{ issue.Number || '-' }}</a>
                  </th>
                  <td>
                    <a *ngIf="issue.SupportTicketID" href="#" [routerLink]="['/tickets/'+  issue.SupportTicketID ]">
                      {{ issue.Title || '-' }}
                    </a>
                    <span *ngIf="!issue.SupportTicketID">
                      {{ issue.Title || '-' }}
                    </span>
                    <span *ngIf="issue.ItemType" [ngClass]="getBadgetClass(issue)">{{ issue.ItemType }}</span>
                  </td>
                  <td class="text-center text-nowrap">
                    <span *ngIf="issue.Status =='Archived' " class="badge bg-success  text-dark">Archived</span>
                    <span *ngIf="issue.Status !='Archived' && issue.SupportTicketID && issue.SupportTicketDateClosed" class="badge bg-danger text-dark">{{ issue.Status || issue.State || '-' }}</span>
                    <span *ngIf="issue.Status !='Archived'" class="badge bg-info"> {{ issue.Status || issue.State || '-' }}</span>
                  </td>
                  <td class="text-center text-nowrap">
                    <span *ngIf="issue.SupportTicketDateClosed" class="badge bg-success  text-dark">Closed</span>
                    <span *ngIf="!issue.SupportTicketDateClosed && issue.SupportTicketStatus && issue.Status =='Archived'" class="badge bg-danger text-dark">{{ issue.SupportTicketStatus }}</span>
                    <span *ngIf="!issue.SupportTicketDateClosed && issue.SupportTicketStatus  && issue.Status !='Archived'" class="badge bg-info"> {{ issue.SupportTicketStatus }}</span>
                  </td>
                  <td class="text-truncate" style="max-width: 200px">
                    {{ issue.Author || '-' }}
                  </td>
                  <td class="text-truncate" style="max-width: 200px">
                    {{ issue.Assignees || '-' }}
                  </td>
                  <td class="text-truncate" style="max-width: 200px">
                    {{ issue.Labels || '-' }}
                  </td>
                  <td class="text-center text-nowrap">
                    {{ issue.UpdatedAt  | date: 'short' }}
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="border border-secondary round-15  p-3 mb-2  bg-white" *ngIf="item.Review">
              <div class="release-notes-body" [innerHTML]="item.Review"></div>
            </div>
            <div class="release-notes-expanded border border-success round-15 mb-2" *ngIf="!loadingDetails">
              <div *ngIf="item.ReleaseNotesCommentId" class="release-notes-body" [innerHTML]="item.ReleaseNotes"></div>
              <div *ngIf="!item.ReleaseNotesCommentId " class="alert alert-warning mb-0">
                Release Notes comment was not found for this release .
              </div>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="6">No release notes found.</td>
        </tr>
      </ng-template>

      <ng-template pTemplate="paginatorleft">
        <button class="btn btn-primary" (click)="loadTable(null)" title="Refresh">
          <i class="pi pi-refresh" [ngClass]="{'pi-spin': loadingList}"></i>
        </button>
        &nbsp;
        <button class="btn btn-primary" (click)="clear(dt1)" title="Clear Filter">
          <i class="pi pi-filter-slash"></i>
        </button>
      </ng-template>
    </p-table>
  </div>
  <div class="main-page-content-block" *ngIf="loadingCurrentItem">
    <div class="row">
      <div class="col ">
        <h1 class="content-heading-font">
          #{{currentItemID}} - Loading...
        </h1>
      </div>
    </div>
  </div>
  <div class="main-page-content-block" *ngIf="currentItem!=null">
    <div class="row">
      <div class="col ">
        <div class="float-end">
          <a class="btn  btn-secondary me-2" [href]="getLink(currentItem)" target="_blank" title="Open GitHub PR">
            <i class="pi pi-external-link"></i>
          </a>

          <a class="btn btn-secondary" (click)="cancel()">View list</a>
        </div>

        <h1 class="content-heading-font">
          {{pageTitle}}
        </h1>
      </div>
    </div>
    <div class="row" *ngIf="currentItem.Items!=null">
      <div class="col ">
        <p-table #dt2
                 dataKey="Number"
                 [value]="currentItem.Items!"
                 [responsive]="true"
                 [paginator]="true"
                 [rows]="25"
                 [showCurrentPageReport]="true"
                 currentPageReportTemplate="Showing {first} to {last} of {totalRecords} issues"
                 [rowsPerPageOptions]="[10, 25, 50, 100, 1000]"
                 styleClass="p-datatable-sm p-datatable-gridlines p-datatable-striped  ">


          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="Number" class="text-center text-nowrap" style="width:150px;">
                Issue # <p-sortIcon field="Number"></p-sortIcon>
                <p-columnFilter type="numeric" field="Number" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="Title" class="text-start">
                Title <p-sortIcon field="Title"></p-sortIcon>
                <p-columnFilter type="text" field="Title" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="Status" class="text-center d-none d-md-table-cell" style="width:160px;">
                Issue Status <p-sortIcon field="Status"></p-sortIcon>
                <p-columnFilter type="text" field="Status" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="PRState" class="text-center d-none d-lg-table-cell" style="width:160px;">
                PR Status <p-sortIcon field="PRState"></p-sortIcon>
                <p-columnFilter type="text" field="PRState" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="SupportTicketStatus" class="text-center d-none d-lg-table-cell" style="width:160px;">
                Ticket Status <p-sortIcon field="SupportTicketStatus"></p-sortIcon>
                <p-columnFilter type="text" field="SupportTicketStatus" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="Author" class="d-none d-xl-table-cell" style="width:160px;">
                Author <p-sortIcon field="Author"></p-sortIcon>
                <p-columnFilter type="text" field="Author" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="Assignees" class=" d-none d-xxl-table-cell" style="width:160px;">
                Assignees <p-sortIcon field="Assignees"></p-sortIcon>
                <p-columnFilter type="text" field="Assignees" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="Labels" class=" d-none d-xxl-table-cell" style="width:160px;">
                Labels <p-sortIcon field="Labels"></p-sortIcon>
                <p-columnFilter type="text" field="Labels" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
              <th pSortableColumn="UpdatedAt" class="text-center d-none d-md-table-cell" style="width:150px;">
                Last Updated <p-sortIcon field="UpdatedAt"></p-sortIcon>
                <p-columnFilter type="date" field="UpdatedAt" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
              </th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-issue>
            <tr>
              <td class="text-center text-nowrap fw-bold">
                <a [href]="getItemLink(issue)" target="_blank" title="Open GitHub Issue">
                  #{{ issue.Number }}
                </a>
              </td>
              <td class="text-start text-break">
                <a *ngIf="issue.SupportTicketID" href="#" [routerLink]="['/tickets/'+  issue.SupportTicketID ]">
                  {{ issue.Title || '-' }}
                </a>
                <span *ngIf="!issue.SupportTicketID">
                  {{ issue.Title || '-' }}
                </span>
                <span *ngIf="issue.ItemType" [ngClass]="getBadgetClass(issue)">{{ issue.ItemType }}</span>
              </td>
              <td class="text-center text-nowrap d-none d-md-table-cell">
                <span *ngIf="issue.Status =='Archived' " class="badge bg-success  text-dark">Archived</span>
                <span *ngIf="issue.Status !='Archived' && issue.SupportTicketID && issue.SupportTicketDateClosed" class="badge bg-danger text-dark">{{ issue.Status || issue.State || '-' }}</span>
                <span *ngIf="issue.Status !='Archived' && (!issue.SupportTicketID || !issue.SupportTicketDateClosed)" class="badge bg-info"> {{ issue.Status || issue.State || '-' }}</span>
              </td>
              <td class="text-center text-nowrap d-none d-lg-table-cell">
                <a [href]="getItemPRLink(issue)" target="_blank" title="Open Pull Request">
                  <span *ngIf="issue.PRState=='MERGED'" class="badge bg-success  text-dark">Merged</span>
                  <span *ngIf="issue.PRNumber && issue.PRState!='MERGED' && issue.Status =='Archived'" class="badge bg-danger text-dark">{{ issue.PRState }}</span>
                  <span *ngIf="issue.PRNumber && issue.PRState!='MERGED' && issue.Status !='Archived'" class="badge bg-info"> {{ issue.PRState }}</span>
                </a>
              </td>
              <td class="text-center text-nowrap  d-none d-lg-table-cell">
                <span *ngIf="issue.SupportTicketDateClosed" class="badge bg-success  text-dark">Closed</span>
                <span *ngIf="!issue.SupportTicketDateClosed && issue.SupportTicketStatus && issue.Status =='Archived'" class="badge bg-danger text-dark">{{ issue.SupportTicketStatus }}</span>
                <span *ngIf="!issue.SupportTicketDateClosed && issue.SupportTicketStatus  && issue.Status !='Archived'" class="badge bg-info"> {{ issue.SupportTicketStatus }}</span>
              </td>
              <td class="text-truncate d-none d-xl-table-cell" style="max-width: 200px">
                {{ issue.Author || '-' }}
              </td>
              <td class="text-truncate  d-none d-xxl-table-cell" style="max-width: 200px">
                {{ issue.Assignees || '-' }}
              </td>
              <td class="text-truncate d-none d-xxl-table-cell" style="max-width: 200px">
                {{ issue.Labels || '-' }}
              </td>
              <td class="text-center text-nowrap d-none d-md-table-cell">
                {{ issue.UpdatedAt  | date: 'short' }}
              </td>
            </tr>
          </ng-template>


        </p-table>

      </div>
    </div>
  </div>
  <div class="main-page-content-block-secondary mt-2" *ngIf="currentItem!=null && currentItem.Review!=null">
    <div class="" [innerHTML]="currentItem.Review"></div>
  </div>
  <div class="main-page-content-block mt-2" *ngIf="currentItem!=null && currentItem.ReleaseNotes!=null">
    <div class="" [innerHTML]="currentItem.ReleaseNotes"></div>
  </div>
</div>
